import type { SxProps, Theme } from '@mui/material'
import { TableCell } from '@mui/material'
import type { ReactNode } from 'react'

interface ISimpleTableCellProps {
  children: ReactNode
  align?: 'left' | 'right' | 'center'
  sx?: SxProps<Theme>
  onClick?: () => void
}

export default function SimpleTableCell({ children, align = 'left', sx, onClick }: ISimpleTableCellProps) {
  return (
    <TableCell align={align} sx={{ ...sx, border: 'none', padding: 1 }} onClick={onClick}>
      {children}
    </TableCell>
  )
}
